// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  height: 100vh;
  --background: transparent ;
}

.w-h-100 {
  width: 100%;
  height: 100vh;
}

.launch-screen {
  text-align: center;
}

.title-page {
  color: var(--color-primary-blue);
  font-weight: bold;
  margin-bottom: 4rem;
  margin-top: 2rem;
}

.label-style {
  color: var(--color-primary-blue);
  margin-right: 0.75rem;
  font-weight: 600;
}

.buttons-main-style {
  margin-top: 3.5rem;
  margin-left: 2.5rem;
}

.back-btn {
  width: 2.688rem;
  height: 2.667rem;
  cursor: pointer;
}

.random-btn {
  font-size: 1rem;
  min-width: 6.667rem;
  height: 1.667rem;
  min-height: 1.667rem;
  --min-height: 1.667rem;
  margin-top: 0.5rem;
  font-weight: 600;
}

.confirm-btn {
  min-width: 14rem;
  height: 2.667rem;
  min-height: 2.667rem;
  --min-height: 2.667rem;
  font-size: 1.167rem;
  margin-top: 0.917rem;
  font-weight: 600;
}

.icon-dice {
  margin-left: 0.417rem;
  width: 1.167rem;
  height: 1rem;
}

.avatar-div .avatar {
  padding-left: 0.8rem;
  height: 10rem;
  display: flex;
  justify-content: center;
}

.ion-col-class {
  display: flex;
  align-items: center;
  padding: 0.1rem;
}
.ion-col-class.left {
  justify-content: flex-end;
}
.ion-col-class .btn-container {
  position: relative;
}
.ion-col-class .btn-container .btn-icon {
  position: absolute;
  color: var(--color-primary-blue);
  cursor: pointer;
}
.ion-col-class .btn-container ion-img.btn-img::part(image) {
  width: 2rem;
  height: 2rem;
  cursor: pointer;
}
.ion-col-class .btn-container .back {
  top: 0.5rem;
  left: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/game/customize-avatar/customize-avatar.page.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,0BAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,gCAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gCAAA;EACA,qBAAA;EACA,gBAAA;AACF;;AAGA;EACE,kBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,qBAAA;EACA,eAAA;EACA,YAAA;AAAF;;AAIE;EACE,oBAAA;EACA,aAAA;EAEA,aAAA;EACA,uBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAHF;AAKE;EACE,yBAAA;AAHJ;AAME;EACE,kBAAA;AAJJ;AAMI;EACE,kBAAA;EACA,gCAAA;EACA,eAAA;AAJN;AAOI;EACE,WAAA;EACA,YAAA;EACA,eAAA;AALN;AAQI;EACE,WAAA;EACA,YAAA;AANN","sourcesContent":["ion-content {\n  height: 100vh;\n  --background: transparent\n}\n\n.w-h-100 {\n  width: 100%;\n  height: 100vh;\n}\n\n.launch-screen {\n  text-align: center;\n}\n\n.title-page {\n  color: var(--color-primary-blue);\n  font-weight: bold;\n  margin-bottom: 4rem;\n  margin-top: 2rem;\n}\n\n.label-style {\n  color: var(--color-primary-blue);\n  margin-right: 0.75rem;\n  font-weight: 600;\n}\n\n\n.buttons-main-style {\n  margin-top: 3.5rem;\n  margin-left: 2.5rem;\n}\n\n.back-btn {\n  width: 2.688rem;\n  height: 2.667rem;\n  cursor: pointer;\n}\n\n.random-btn {\n  font-size: 1rem;\n  min-width: 6.667rem;\n  height: 1.667rem;\n  min-height: 1.667rem;\n  --min-height: 1.667rem;\n  margin-top: 0.5rem;\n  font-weight: 600;\n}\n\n.confirm-btn {\n  min-width: 14rem;\n  height: 2.667rem;\n  min-height: 2.667rem;\n  --min-height: 2.667rem;\n  font-size: 1.167rem;\n  margin-top: 0.917rem;\n  font-weight: 600;\n}\n\n.icon-dice {\n  margin-left: 0.417rem;\n  width: 1.167rem;\n  height: 1rem;\n}\n\n.avatar-div {\n  .avatar {\n    padding-left: 0.8rem;\n    height: 10rem;\n    // width: 6rem;\n    display: flex;\n    justify-content: center;\n  }\n}\n\n.ion-col-class {\n  display: flex;\n  align-items: center;\n  padding: 0.1rem;\n\n  &.left {\n    justify-content: flex-end;\n  }\n\n  .btn-container {\n    position: relative;\n\n    .btn-icon {\n      position: absolute;\n      color: var(--color-primary-blue);\n      cursor: pointer;\n    }\n\n    ion-img.btn-img::part(image) {\n      width: 2rem;\n      height: 2rem;\n      cursor: pointer;\n    }\n\n    .back {\n      top: 0.5rem;\n      left: 0.5rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
